import { render, staticRenderFns } from "./ltv.vue?vue&type=template&id=5fd558ae&"
import script from "./ltv.vue?vue&type=script&lang=js&"
export * from "./ltv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports